import { GameScene } from "../scenes/GameScene";
import { BGLayer } from "./ScrollingBG";
import { Wall } from "./Wall";

export class EndingDeco {

	static create(scene: GameScene, mgLayer: BGLayer, backlotLayer: BGLayer, crowdLayer: BGLayer, stageLayer: BGLayer) {
		// align layers to wall
		const wall = scene.objects.find(o => o instanceof Wall);
		if (!wall) return;
		const startX = wall.x + wall.width / 2;
		const groundHeight = scene.ltGame.chunkSpawner.groundHeight;
		for (const layer of [mgLayer, backlotLayer, crowdLayer, stageLayer]) {
			layer.xOffset = startX;
			layer.yOffset = -groundHeight;
		}

		const addImage = (layer: BGLayer, key: string, x: number, y: number) => {
			const img = layer.addImage(key);
			img.setOrigin(0, 1);
			img.setPosition(x, y);
			return img;
		}

		// ground
		let ground: Phaser.GameObjects.Image;
		for (let i = 0; i < 13; i++) {
			ground = addImage(backlotLayer, "endingGround", 1089 * i, 0);
			addImage(backlotLayer, "endingGround", 1089 * i, 246);
		}
		const groundY = ground.y - ground.height;

		// backlot layer
		let wallX: number;
		let wallY: number;
		for (let x = 0; x < 13; x++) {
			for (let y = 0; y < 4; y++) {
				const img = addImage(backlotLayer, "backlotWall", 286 * x - 50, groundY - (286 * y));
				wallX = img.x + img.width;
				wallY = img.y - img.height;
			}
		}
		for (let x = 0; x < 14; x++) {
			addImage(backlotLayer, "backlotTop", 256 * x, wallY + 4);
		}
		addImage(backlotLayer, "backlotFrontWall", wallX - 29, groundY + 2);
		addImage(backlotLayer, "backlotFrontWallTop", wallX - 134, wallY + 122);

		for (let i = 1; i <= 5; i++) {
			addImage(backlotLayer, "endingBillboard" + i, i * 650 - 300, -750);
		}

		const haze = addImage(backlotLayer, "backlotWallHaze", -50, groundY);
		haze.displayWidth = 286 * 13;

		addImage(backlotLayer, "endingSign", 200, groundY);

		// crowd layer
		const crowdY = groundY * 0.6;
		const spawnCrowd = (crowdX: number): number => {
			const crowdStart = addImage(crowdLayer, "endingCrowd3", crowdX, crowdY);
			crowdStart.scaleX = -1;
			crowdStart.originX = 1;
			let crowdMidEndX: number;
			for (let i = 0; i < 3; i++) {
				const crowdMid = addImage(crowdLayer, "endingCrowd" + (i % 2 + 1), crowdStart.x + (i * 1024), crowdY);
				crowdMidEndX = crowdMid.x + crowdMid.width;
			}
			const crowdEnd = addImage(crowdLayer, "endingCrowd3", crowdMidEndX, crowdY);

			const poleY = crowdY + 2;
			const pole = addImage(crowdLayer, "endingRopePole", crowdX - crowdStart.width, poleY);
			pole.x -= pole.width / 2;
			for (let i = 0; i < 13; i++) {
				addImage(crowdLayer, "endingRope", (pole.x + pole.width / 2) + (i * 268), poleY);
			}

			return crowdEnd.x + crowdEnd.width;
		}
		const crowd1End = spawnCrowd(2450);
		spawnCrowd(crowd1End + 1300);

		const balloons1 = addImage(crowdLayer, "endingBalloons", crowd1End - 700, crowdY + 40);
		const balloons2 = addImage(crowdLayer, "endingBalloons", crowd1End + 1400, crowdY + 40);
		balloons1.scale = 0.8;
		balloons2.scale = 0.8;

		// stage layer
		const stageX = 9210;
		addImage(stageLayer, "backlotStageTop", stageX + 55, -83);
		const stageBottom = addImage(stageLayer, "backlotStageBottom", stageX, groundHeight);
		stageBottom.name = "stage";
		const stageMidX = (stageBottom.x + stageBottom.width / 2);
		addImage(stageLayer, "endingCharacters", stageX + 200, groundHeight - 20);

		addImage(stageLayer, "endingBalloons", stageX - 300, 20);
		addImage(stageLayer, "endingBalloons", stageX + 1300, 20);

		const pile = addImage(stageLayer, "endingExplosivePile", stageMidX, groundHeight);
		pile.setOrigin(1, 1);
		pile.setPosition(stageMidX + scene.viewport.width/2 + 20, groundHeight)
		pile.name = "explosivePile";

		const leftTrumpets = addImage(stageLayer, "backlotTrumpets", stageMidX - 800 - 247, groundHeight + 20);
		const rightTrumpets = addImage(stageLayer, "backlotTrumpets", stageMidX + 800 + 247, groundHeight + 20);
		leftTrumpets.name = "trumpets";
		rightTrumpets.name = "trumpets";
		rightTrumpets.originX = 1;
		rightTrumpets.scaleX = -1;

		// wb tower
		const tower = addImage(mgLayer, "endingWBTower", 3000, 0);
		const towerMirror = addImage(mgLayer, "endingWBTower", 3000, 0);
		towerMirror.scaleX = -20;
		const startTweens  = [];

		const lightBucketL = addImage(stageLayer, "backlotStageLightBucket", stageMidX - 525 , groundHeight - 275);
		const lightBucketR = addImage(stageLayer, "backlotStageLightBucket", stageMidX + 520, groundHeight - 275);
		const lightBaseL = addImage(stageLayer, "backlotStageLightBase", stageMidX - 545, groundHeight - 220);
		const lightBaseR = addImage(stageLayer, "backlotStageLightBase", stageMidX + 460, groundHeight - 220);
		lightBucketL.setOrigin(0.91, 0.9);
		lightBucketR.setFlipX(true);
		lightBucketR.setOrigin(0.09, 0.9);
		lightBaseR.setFlipX(true);
		const t2 = scene.tweens.create({
			targets: lightBucketL,
			angle: lightBucketL.angle - 25,
			duration: 1000,
			yoyo: true,
			loop: -1,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});
		const t3 = scene.tweens.create({
			targets: lightBucketR,
			angle: lightBucketR.angle + 25,
			duration: 1000,
			yoyo: true,
			loop: -1,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});
		startTweens.push(t2, t3);
		for(const tween of startTweens) tween.play();
	}
}